// @ts-check
import { getValueByNs, isDefined } from '../../utils/index.js';

// TODO: Refactor these functions - Add typings. Optimize. Move all API object manipulations here.

export function generateSpecificProductsObject(productsArray) {
  const productsObject = {};

  if (getValueByNs(productsArray, 'length', 0)) {
    productsArray.forEach((product) => {
      if (product.hasOwnProperty('ProductId')
        && (product.hasOwnProperty('QuantityRequested') || product.hasOwnProperty('Quantity'))) {
        productsObject[product.ProductId] = product.QuantityRequested;
      }
    });
  }

  return productsObject;
}

/**
 * Returns product available online
 * @param {*[]} retailerCarts
 * @returns {Object} - Object containing products available online across any retailer
 */
function getProductsAvailableOnline(retailerCarts) {
  let productsAvailableOnline = {};

  retailerCarts.forEach((retailer) => {
    if (getValueByNs(retailer, 'ProductsCarriedInStock.length', 0) > 0) {
      productsAvailableOnline = {
        ...productsAvailableOnline,
        ...generateSpecificProductsObject(retailer.ProductsCarriedInStock)
      };
    }

    if (getValueByNs(retailer, 'ProductsCarriedOutOfStock.length', 0) > 0) {
      productsAvailableOnline = {
        ...productsAvailableOnline,
        ...generateSpecificProductsObject(retailer.ProductsCarriedOutOfStock)
      };
    }
  });

  return productsAvailableOnline;
}

/**
 * Returns products unavailable online
 * @param {*[]} retailerCarts
 * @returns {Object} - Object containing products unavailable online across all retailers
 */
export function getProductsUnavailableOnline(retailerCarts) {
  const productsUnavailableOnline = {};

  retailerCarts.forEach((retailer) => {
    if (getValueByNs(retailer, 'ProductsNotCarried.length', 0) > 0) {
      retailer.ProductsNotCarried.forEach((product) => {
        if (!getProductsAvailableOnline(retailerCarts).hasOwnProperty(product.ProductId)) {
          productsUnavailableOnline[product.ProductId] = product.Quantity;
        }
      });
    }
  });

  return productsUnavailableOnline;
}

/**
 * @param {string[]} productIds
 * @param {*[]} productsInCart
 */
export function findProductsInCartById(productIds, productsInCart) {
  return productIds.reduce((result, productId) => {
    const foundProduct = productsInCart.find((product) => product.commRef === productId);

    if (isDefined(foundProduct)) {
      result.push(foundProduct);
    }

    return result;
  }, []);
}

/**
 * @param {Object} retailer
 * @param {Object} totalProductsQuantity
 * @param {Object} unavailableProductsObject
 */
export function getDisplayedProductsQuantity(retailer, totalProductsQuantity, unavailableProductsObject) {
  if (unavailableProductsObject && getValueByNs(retailer, 'ProductsNotCarried.length', 0)) {
    return totalProductsQuantity - Object.keys(unavailableProductsObject).length;
  }

  return totalProductsQuantity;
}
